enum AemConstants {
  RESOURCE_TYPE = 'sling:resourceType',
  TYPE = ':type',
  ITEMS = ':items',
  ITEMS_ORDER = ':itemsOrder',
  ALLOWED_COMPONENTS = 'allowedComponents',
  COLUMN_CLASS_NAMES = 'columnClassNames',
  LAST_MODIFIED_DATE = 'lastModifiedDate',
  DESIGN_PATH = 'designPath',
  HTML_PAGE_ITEMS = 'htmlPageItems',
}

export { AemConstants };
